/**
 * NotificationResponseData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { NotificationResponse } from './notification_response'
import type { UserInfo } from './user_info'

/**
 * NotificationResponseData
 */
export interface NotificationResponseData {
  /** 响应基础信息 */
  info?: NotificationResponse
  /** 接收者信息 */
  receiver_info?: UserInfo
}

/**
 * NotificationResponseData Schema
 */
export const NotificationResponseDataSchema: SchemaDefinition = {
  properties: {
    info: {
      $ref: 'NotificationResponse',
      description: '响应基础信息',
      label: '响应基础信息',
    },
    receiver_info: {
      $ref: 'UserInfo',
      description: '接收者信息',
      label: '接收者信息',
    },
  },
  type: 'object',
}
